export default function Integrations({options}) {
    <div></div>
}